import { extractSingleData } from "@shared/utils/extract-dto-data";
import { safeParseWithFallback } from "@shared/utils/safe-parse-with-fallback";

import {
  type HowToGetSectionBase,
  HowToGetSectionDtoSchema,
} from "../schemas/sections.schema";

export const mapDtoToHowToGetSection = (
  dto: unknown,
): HowToGetSectionBase | null => {
  const parsed = safeParseWithFallback(
    HowToGetSectionDtoSchema,
    dto,
    "mapDtoToHowToGetSection",
  );

  return extractSingleData<HowToGetSectionBase>(parsed, dto);
};
